export default __webpack_public_path__ + "static/media/330_dummy2016-coach02-mobile-de.625e6f9b.png";